import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const tableList: ITkFakeTableLineProps[] = [
  {
    title: "年度",
    keyword: "year",
    type: "text",
  },
  {
    title: "都道府県",
    keyword: "prefectureCd",
    type: "text",
  },
  {
    title: "単位金額",
    keyword: "unitAmt",
    type: "text",
  },
  {
    title: "人数",
    keyword: "staffNum",
    type: "text",
  },
  {
    keyword: "payApplyAmt",
    type: "text",
  },
  {
    keyword: "payApply",
    type: "node",
  },
  {
    keyword: "yearAllPayApply",
    type: "node",
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "回答",
  },
  {
    title: "担当部署",
    keyword: "managerDeployment",
    inputProps: { maxLength: 85 },
    disabled: true,
  },
  {
    title: "担当者名",
    keyword: "managerName",
    inputProps: { maxLength: 47 },
    disabled: true,
  },
  {
    title: "連絡先電話番号",
    keyword: "contactTel",
    type: "phoneNum",
    disabled: true,
  },
  {
    title: "連絡先FAX番号",
    keyword: "contactFax",
    type: "phoneNum",
    disabled: true,
  },
  {
    title: "交付決定予定時期",
    keyword: "planDate",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    disabled: true,
  },
  {
    title: "交付決定予定額",
    keyword: "planAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "支出予定時期",
    keyword: "dueDate",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    disabled: true,
  },
  {
    title: "支出予定額",
    keyword: "paymentPlanAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "支出回数",
    keyword: "paymentTimes",
    inputProps: { maxLength: 2 },
    disabled: true,
  },
  {
    type: "node",
    keyword: "memo",
    showLine: false,
  },
];

const schema = {
  managerDeployment: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  managerName: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  contactTel: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "19"),
    },
  },
  contactFax: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "19"),
    },
  },
  paymentPlanAmt: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  estimatePlanAmt: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentTimes: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "2"),
    },
  },
};

const headList = [
  { headTitle: " " },
  { headTitle: "施設種類区分" },
  { headTitle: "保護施設" },
  { headTitle: "児童福祉施設" },
  { headTitle: "老人福祉施設" },
  { headTitle: "その他の社会福祉施設" },
  { headTitle: "特定社会福祉事業" },
  {
    top: { headTitle: "特定介護保険施設" },
    bottom: [
      { headTitle: "介護保険施設等" },
      { headTitle: "障碍者支援施設等" },
    ],
  },
  { headTitle: "合計" },
];

export { tableList, schema, headList };
